import React, { useState } from "react";
import SwitchButton from "../../components/FormFields/SwitchButton";
import WrapperWithTabs from "../../components/WrapperWithTabs";
import { icons } from "../../assets/icons";
import { usersListColumns } from "../../components/Columns/Users";
import useApi from "../../hooks/useApi";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTable from "../../components/CustomTable";
import CustomButton from "../../components/CustomButton";
import ToolbarHeader from "../../components/ToolbarHeader";
import { groupUsersColumns } from "../../components/Columns/GroupUsers";
import { groupRolesColumns } from "../../components/Columns/GroupRoles";

const GroupDescription = () => {
  const { data = [], apiCall, data: roles = [], apiCall: getRoles, } = useApi();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    active: true,
  });


  const { name = "", groupRoles = {}, groupUsers = {} } = state || {}
  const customRoleUserObj = [
    { groupName: name, groupUsers: groupUsers, groupRoles: groupRoles },
  ];

  const transformGroupUserAndGroupRoles = (inputData) => {
    return inputData.reduce((result, item) => {
      const { groupName, groupUsers, groupRoles } = item;
  
      // Process groupUsers
      if (groupUsers) {
        const groupUserNames = Object.keys(groupUsers).map((key) => ({
          groupName,
          groupUsers: groupUsers[key],
        }));
        result.push({ groupUserNames });
      }
  
      // Process groupRoles
      if (groupRoles) {
        const groupRoleNames = Object.keys(groupRoles).map((key) => ({
          groupName,
          groupRoles: groupRoles[key],
        }));
        result.push({ groupRoleNames });
      }
  
      return result;
    }, []);
  }
  
  // Example usage:
  const inputData = [
    { groupName: "Ja", groupUsers: { 11: "Jatin007" }, groupRoles: { 8: "TestRole" } },
    // Add more objects if needed
  ];
  
  const result = transformGroupUserAndGroupRoles(inputData);
  const onCheckboxSelect = (groups = []) => {
    if(groups.length > 0){
      let groupIds = groups?.map(i => i.original.id)
      setFormData({...formData, groupIds: groupIds})
    }
  }


  const AssignRoleCheckboxSelect = (roles = []) => {
    if(roles.length > 0){
      let roleIds = roles?.map(i => i.original.id)
      setFormData({...formData, roleIds: roleIds})
    }
  }


  const tabBarOptions =
  [
    {
      id: 1,
      title: "Group Users",
      Component: ({ data }) => {
        return (
          <div className="mb-4">
            <div className="flex justify-end mb-4 mt-4">
              {/* <InputWithIcon
                placeholder="Search Roles"
                containerClassName="search-input-wrapper"
                wrapperClassName="!h-[4rem]"
                inputClassName="font-size-small"
                rightIcon={icons.searchIcon}
                //   onChange={(e) => setSearchText(e)}
                //   value={searchText}
              /> */}
              {/* <CustomButton
                title="Create Group"
                wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
                textClassName="text-[var(--blackColor)] pl-2"
                icon={icons.plusBlackIcon}
                onClick={() => {
                  navigate("/groups/create");
                }}
              /> */}
            </div>
            <CustomTable
              isGlobalSearchEnable={true}
              // globalSearchPosition={{
              //   position: "absolute",
              //   top: "-53px",
              //   // left: "176px",
              // }}
              // showCheckboxes={true}
              onCheckboxSelect={onCheckboxSelect}
              data={transformGroupUserAndGroupRoles(customRoleUserObj)?.[0]?.groupUserNames || []}
              columns={groupUsersColumns()}
            />
          </div>
        );
      },
    },
    // {
    //   id: 2,
    //   title: "Group Roles",
    //   Component: ({ roles }) => {
    //     return (
    //       <div className="mb-4">
    //         <div className="flex justify-end mb-4 mt-4">
    //           {/* <InputWithIcon
    //             placeholder="Search Roles"
    //             containerClassName="search-input-wrapper"
    //             wrapperClassName="!h-[4rem]"
    //             inputClassName="font-size-small"
    //             rightIcon={icons.searchIcon}
    //             //   onChange={(e) => setSearchText(e)}
    //             //   value={searchText}
    //           /> */}
    //           {/* <CustomButton
    //             title="Create Group"
    //             wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
    //             textClassName="text-[var(--blackColor)] pl-2"
    //             icon={icons.plusBlackIcon}
    //           /> */}
    //         </div>
    //         <CustomTable
    //           isGlobalSearchEnable={true}
    //           // globalSearchPosition={{
    //           //   position: "absolute",
    //           //   top: "-53px",
    //           //   // left: "176px",
    //           // }}
    //           // showCheckboxes={true}
    //           data={transformGroupUserAndGroupRoles(customRoleUserObj)?.[1]?.groupRoleNames || []}
    //           onCheckboxSelect={AssignRoleCheckboxSelect}
    //           columns={groupRolesColumns()}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  const onClickBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <ToolbarHeader
        title="Groups > Description"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          return (
            <div className="flex items-center gap-x-6">
              <CustomButton
                title="Back"
                wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
                textClassName="text-[var(--blackColor)] pl-2"
                onClick={onClickBack}
                icon={icons.backIcon}
              />
            </div>
          );
        }}
      />
      <WrapperWithTabs tabBarOptions={tabBarOptions} commonProps={{data, roles}} wrapperClassName="mt-12" />
    </div>
  );
};

export default GroupDescription;
